module.exports = __webpack_public_path__ + "static/media/carousel-6.739de9f9.jpg";